import { SubmitType, TaskList } from "../../types"

/** Payload PUT /task/:id dari baris list (mis. drag board) — field sama dengan submitMap edit. */
export function taskListToSubmitPayload(
  row: TaskList,
  task_status: number
): SubmitType {
  return {
    trx_code: row.trx_code,
    location_id: row.location_id,
    departement_id: row.departement_id,
    project_id: row.project_id,
    mr_group_task_id: row.mr_group_task_id,
    mr_group_sub_id: row.mr_group_sub_id,
    task_status,
    subject: row.subject,
    priority: row.priority,
    date_start: row.date_start,
    date_end: row.date_end,
    owner_task_id: row.owner_task_id,
    description: row.description ?? ""
  }
}
